import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import Navbar from '@softwaredev_cegeka/stix-core/dist/components/Navbar'
import ButtonToolbar from '@softwaredev_cegeka/stix-core/dist/components/ButtonToolbar'
import useTranslations from 'src/hooks/useTranslations'
import { reverse } from 'src/routes/config'
import useUserData from 'src/hooks/useUserData'
import { isAnyAllowed, HR_PROFILE_PERMISSION } from 'src/utils/permissions'

import styles from './SettingsNavbar.module.scss'

const ACTIVE_CLASS_NAME = 'ACTIVATED'

const NavLinkButton = React.forwardRef((props, ref) => {
    const isActive = props.className === ACTIVE_CLASS_NAME

    const handleClick = event => {
        event.preventDefault()
        props.navigate()
    }

    return (
        <Navbar.Button
            {...props}
            ref={ref}
            active={isActive}
            size="lg"
            onClick={handleClick}
        />
    )
})
function SettingsNavbar({ variant }) {
    const { t } = useTranslations('Navbar', 'Navbar')
    const userData = useUserData()
    const isAccountAccessAllowed = isAnyAllowed(userData, [
        HR_PROFILE_PERMISSION,
    ])
    return (
        <Navbar variant={variant} className={styles.navbar}>
            <ButtonToolbar className={styles.nav}>
                {isAccountAccessAllowed && (
                    <NavLink
                        key="nav-link-profile"
                        to={reverse('profile-settings')}
                        component={NavLinkButton}
                        activeClassName={ACTIVE_CLASS_NAME}
                    >
                        {t('Account')}
                    </NavLink>
                )}
                <NavLink
                    key="nav-link-notifications"
                    to={reverse('notifications-settings')}
                    component={NavLinkButton}
                    activeClassName={ACTIVE_CLASS_NAME}
                >
                    {t('Notifications')}
                </NavLink>
            </ButtonToolbar>
        </Navbar>
    )
}

SettingsNavbar.propTypes = {
    variant: PropTypes.string,
}

SettingsNavbar.defaultProps = {
    variant: 'secondary-60',
}

export default SettingsNavbar
